var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMuteOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.0416 42.375H84.75V37.6667H80.0416V42.375Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.75 47.0833H89.4583V42.375H84.75V47.0833Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.75 70.625H89.4583V65.9167H84.75V70.625Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0416 75.3333H84.75V70.625H80.0416V75.3333Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.625 51.7917H75.3333V47.0833H70.625V51.7917Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.625 65.9167H75.3333V61.2083H70.625V65.9167Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1666 47.0833H89.4583V65.9167H94.1666V47.0833Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0416 51.7917H75.3333V61.2083H80.0416V51.7917Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0833 80.0417V84.75H56.5V80.0417H47.0833Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6666 75.3333V80.0417H47.0833V75.3333H37.6666Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 70.625V75.3333H37.6666V70.625H28.25Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 42.375H23.5416V70.625H28.25V42.375Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6666 42.375V37.6667H28.25V42.375H37.6666Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0833 37.6667V32.9583H37.6666V37.6667H47.0833Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 32.9583V28.25H47.0833V32.9583H56.5Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 80.0417H61.2083V32.9583H56.5V80.0417Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 70.6249V42.3749H37.6667V37.6666H47.0833V32.9583H56.5V80.0416H47.0833V75.3332H37.6667V70.6249H28.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteOn);
export default __webpack_public_path__ + "static/media/mute_on.bd48d5243cbaa172f725729ebcdc19fe.svg";
export { ForwardRef as ReactComponent };